import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import ICONS from "../config/icon";
import { MonoButton } from "../kits";

function EditCourse() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [skills, setSkills] = useState([]);
  const [selectedSkills, setSelectedSkills] = useState([]);

  useEffect(() => {
    async function fetchData() {
      try {
        const resCourse = await fetch(`https://www.denisbitter.de/stage01/api/get_courses.php?slug=${slug}`);
        if (!resCourse.ok) throw new Error("Fehler beim Laden.");
        const data = await resCourse.json();

        if (data.success && data.data) {
          const courseData = data.data;
          let parsedProgram = [];
          try {
            parsedProgram = Array.isArray(courseData.courseProgram)
              ? courseData.courseProgram
              : JSON.parse(courseData.courseProgram || "[]");
            if (!Array.isArray(parsedProgram)) parsedProgram = [];
          } catch (e) {
            console.warn("courseProgram konnte nicht geparst werden", e);
          }

          setFormData({
            ...courseData,
            description: Array.isArray(courseData.description)
              ? courseData.description
              : [courseData.description || ""],
            descriptionExtension: Array.isArray(courseData.descriptionExtension)
              ? courseData.descriptionExtension
              : courseData.descriptionExtension
                ? [courseData.descriptionExtension]
                : [""],
            courseProgram: parsedProgram
          });

          const skillIds = (courseData.skills || []).map((s) => Number(s.id));
          setSelectedSkills(skillIds);
        }

        const resSkills = await fetch("https://www.denisbitter.de/stage01/api/get_all_skills.php");
        const skillData = await resSkills.json();
        if (skillData.success) setSkills(skillData.data);

        setLoading(false);
      } catch (err) {
        console.error(err);
        setError(err.message);
        setLoading(false);
      }
    }

    fetchData();
  }, [slug]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value
    }));
  };

  const toggleSkill = (id) => {
    setSelectedSkills((prev) =>
      prev.includes(id) ? prev.filter((sid) => sid !== id) : [...prev, id]
    );
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Stelle sicher, dass ratingValue immer als Dezimal mit Punkt gespeichert wird
    const sanitizedRatingValue =
      typeof formData.ratingValue === "string"
        ? formData.ratingValue.replace(",", ".")
        : formData.ratingValue;

const updatedFormData = {
  ...formData,
  isFavorite: formData.isFavorite ? "1" : "0",
  price: Number(formData.price),
  priceOnline: Number(formData.priceOnline),
  ratingValue: Number(formData.ratingValue),
  description: formData.description.filter((line) => line.trim() !== ""),
  descriptionExtension: Array.isArray(formData.descriptionExtension)
    ? formData.descriptionExtension.join(" ") // oder .join("\n")
    : formData.descriptionExtension,
  courseProgram: Array.isArray(formData.courseProgram)
    ? formData.courseProgram
    : JSON.parse(formData.courseProgram || "[]"),
  skills: selectedSkills,
  registeredCount: Number(formData.registeredCount),
};

     console.log("Wird gesendet:", JSON.stringify(updatedFormData, null, 2)); // <-- HIER ist es korrekt!

    try {
      const res = await fetch("https://www.denisbitter.de/stage01/api/update_course.php", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(updatedFormData)
      });

      if (!res.ok) throw new Error("Fehler beim Speichern.");

      alert("Kurs aktualisiert!");
      navigate("/admindashboard");
    } catch (err) {
      console.error(err);
      alert("Fehler beim Speichern: " + err.message);
    }
  };

  if (loading) return <p>Lade Daten...</p>;
  if (error) return <p className="text-red-500">{error}</p>;
  if (!formData) return <p>Keine Daten gefunden.</p>;

  return (
    <form onSubmit={handleSubmit} className="max-w-2xl mx-auto bg-white shadow-md rounded px-8 pt-6 pb-8 mb-4 text-xs">
      <h2 className="text-sm bg-black text-slate-50 font-bold mb-4 mt-4 px-3 pt-4 pb-4 rounded-lg ">Kurs bearbeiten</h2>
      <div className="grid grid-cols-2 gap-4 text-xs">
        {[
          "title",
          "slug",
          "instructor",
          "lectures",
          "price",
          "priceOnline",
          "videoUrl"
        ].map((field) => (
          <div key={field}>
            <label htmlFor={field} className="block text-gray-700 text-xs font-bold mb-2">{field}</label>
            <input
              id={field}
              name={field}
              type="text"
              value={formData[field] || ""}
              onChange={handleChange}
              className="w-full px-3 py-2 border rounded text-xs"
            />
          </div>
        ))}

        <div>
          <label htmlFor="isFavorite" className="block text-gray-700 text-xs font-bold mb-2 ">Favorit</label>
          <input
            id="isFavorite"
            name="isFavorite"
            type="checkbox"
            checked={formData.isFavorite || false}
            onChange={handleChange}
            className="w-5 h-5"
          />
        </div>

        <div>
          <label htmlFor="ratingValue" className="block text-gray-700 text-xs font-bold mb-2">Bewertung (z. B. 4.8)</label>
          <input
            id="ratingValue"
            name="ratingValue"
            type="number"
            step="0.01"
            min="0"
            max="5"
            value={formData.ratingValue || ""}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded text-xs"
            inputMode="decimal"
            pattern="[0-9]+([.,][0-9]+)?"
          />
        </div>

        <div>
          <label htmlFor="registeredCount" className="block text-gray-700 text-xs font-bold mb-2">Anzahl Teilnehmer</label>
          <input
            id="registeredCount"
            name="registeredCount"
            type="number"
            min="0"
            value={formData.registeredCount || ""}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded text-xs"
          />
        </div>

        <div>
          <label htmlFor="icon" className="block text-gray-700 text-xs font-bold mb-2">Icon</label>
          <select
            id="icon"
            name="icon"
            value={formData.icon || ""}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded text-xs"
          >
            {Object.keys(ICONS).map((key) => (
              <option key={key} value={key}>{key}</option>
            ))}
          </select>
        </div>

        <div>
          <label htmlFor="startDate" className="block text-gray-700 text-xs font-bold mb-2">Startdatum</label>
          <input
            id="startDate"
            name="startDate"
            type="date"
            value={formData.startDate || ""}
            onChange={handleChange}
            className="w-full px-3 py-2 border rounded text-xs"
          />
        </div>
      </div>

      {/* Beschreibung als Listeneditor */}
      <div className="mb-4">
        <label className="block text-xs font-bold mb-2">Beschreibung</label>
        {formData.description.map((line, idx) => (
          <div key={idx} className="flex items-center mb-2 gap-2">
            <input
              type="text"
              value={line}
              onChange={e => {
                const updated = [...formData.description];
                updated[idx] = e.target.value;
                setFormData(prev => ({ ...prev, description: updated }));
              }}
              className="w-full px-3 py-2 border rounded text-xs"
            />
            {/* Hoch */}
            <button
              type="button"
              onClick={() => {
                if (idx === 0) return;
                const updated = [...formData.description];
                [updated[idx - 1], updated[idx]] = [updated[idx], updated[idx - 1]];
                setFormData(prev => ({ ...prev, description: updated }));
              }}
              className="text-xs text-gray-600 px-1 py-1 rounded hover:bg-gray-100 disabled:opacity-30"
              disabled={idx === 0}
              title="Nach oben"
            >▲</button>
            {/* Runter */}
            <button
              type="button"
              onClick={() => {
                if (idx === formData.description.length - 1) return;
                const updated = [...formData.description];
                [updated[idx + 1], updated[idx]] = [updated[idx], updated[idx + 1]];
                setFormData(prev => ({ ...prev, description: updated }));
              }}
              className="text-xs text-gray-600 px-1 py-1 rounded hover:bg-gray-100 disabled:opacity-30"
              disabled={idx === formData.description.length - 1}
              title="Nach unten"
            >▼</button>
            {/* Entfernen */}
            <button
              type="button"
              onClick={() => {
                const updated = [...formData.description];
                updated.splice(idx, 1);
                setFormData(prev => ({ ...prev, description: updated }));
              }}
              className="text-xs text-red-500 px-2 py-1 rounded hover:bg-red-100"
              title="Entfernen"
            >–</button>
          </div>
        ))}
        <button
          type="button"
          onClick={() =>
            setFormData(prev => ({
              ...prev,
              description: [...prev.description, ""]
            }))
          }
          className="text-xs text-green-600 mt-2"
        >+ Eintrag hinzufügen</button>
      </div>

      {/* Erweiterte Beschreibung als Listeneditor */}
      <div className="mb-4">
        <label className="block text-xs font-bold mb-2">Erweiterte Beschreibung</label>
        {formData.descriptionExtension.map((line, idx) => (
          <div key={idx} className="flex items-center mb-2 gap-2">
            <input
              type="text"
              value={line}
              onChange={e => {
                const updated = [...formData.descriptionExtension];
                updated[idx] = e.target.value;
                setFormData(prev => ({ ...prev, descriptionExtension: updated }));
              }}
              className="w-full px-3 py-2 border rounded text-xs"
            />
            <button
              type="button"
              onClick={() => {
                const updated = [...formData.descriptionExtension];
                updated.splice(idx, 1);
                setFormData(prev => ({ ...prev, descriptionExtension: updated }));
              }}
              className="text-xs text-red-500 px-2 py-1 rounded hover:bg-red-100"
              title="Entfernen"
            >–</button>
          </div>
        ))}
        <button
          type="button"
          onClick={() =>
            setFormData(prev => ({
              ...prev,
              descriptionExtension: [...prev.descriptionExtension, ""]
            }))
          }
          className="text-xs text-green-600 mt-2"
        >+ Eintrag hinzufügen</button>
      </div>

      <div className="mb-6">
        <label className="block text-xs font-bold mb-2">Course Program</label>
        {formData.courseProgram.map((day, dayIndex) => (
          <div key={dayIndex} className="border p-4 mb-4 rounded bg-gray-50">
            <input
              type="text"
              value={day.day}
              onChange={(e) => {
                const updated = [...formData.courseProgram];
                updated[dayIndex].day = e.target.value;
                setFormData((prev) => ({ ...prev, courseProgram: updated }));
              }}
              placeholder="z. B. 'Tag 1'"
              className="w-full mb-2 px-3 py-2 border rounded"
            />
            {day.schedule.map((entry, entryIndex) => (
              <div key={entryIndex} className="grid grid-cols-3 gap-2 mb-2">
                <input
                  type="text"
                  value={entry.time}
                  onChange={(e) => {
                    const updated = [...formData.courseProgram];
                    updated[dayIndex].schedule[entryIndex].time = e.target.value;
                    setFormData((prev) => ({ ...prev, courseProgram: updated }));
                  }}
                  placeholder="Uhrzeit"
                  className="px-2 py-1 border rounded"
                />
                <input
                  type="text"
                  value={entry.topic}
                  onChange={(e) => {
                    const updated = [...formData.courseProgram];
                    updated[dayIndex].schedule[entryIndex].topic = e.target.value;
                    setFormData((prev) => ({ ...prev, courseProgram: updated }));
                  }}
                  placeholder="Thema"
                  className="px-2 py-1 border rounded"
                />
                <input
                  type="text"
                  value={entry.details}
                  onChange={(e) => {
                    const updated = [...formData.courseProgram];
                    updated[dayIndex].schedule[entryIndex].details = e.target.value;
                    setFormData((prev) => ({ ...prev, courseProgram: updated }));
                  }}
                  placeholder="Details"
                  className="px-2 py-1 border rounded"
                />
              </div>
            ))}
            <button
              type="button"
              onClick={() => {
                const updated = [...formData.courseProgram];
                updated[dayIndex].schedule.push({ time: "", topic: "", details: "" });
                setFormData((prev) => ({ ...prev, courseProgram: updated }));
              }}
              className="text-xs text-blue-600"
            >+ Eintrag hinzufügen</button>
          </div>
        ))}
        <button
          type="button"
          onClick={() => {
            const updated = [...formData.courseProgram, { day: `Tag ${formData.courseProgram.length + 1}`, schedule: [] }];
            setFormData((prev) => ({ ...prev, courseProgram: updated }));
          }}
          className="text-xs text-green-600"
        >+ KursTag hinzufügen</button>
      </div>

      <div className="mb-6">
        <label className="block text-xs font-bold mb-2">Skills</label>
        <div className="grid grid-cols-2 gap-2">
          {skills.map((skill) => (
            <label key={skill.id} className="flex items-center space-x-2">
              <input
                type="checkbox"
                checked={selectedSkills.includes(Number(skill.id))}
                onChange={() => toggleSkill(Number(skill.id))}
              />
              <span>{skill.name}</span>
            </label>
          ))}
        </div>
      </div>

      <div className="mt-6 space-y-2">
        <MonoButton
          type="submit"
          className="w-full px-4 rounded"
        >Speichern</MonoButton>

        <MonoButton
          type="button"
          onClick={() => navigate("/admindashboard")}
          className="w-full px-4 rounded"
        >Abbrechen</MonoButton>
      </div>
    </form>
  );
}

export default EditCourse;
